import types from '../types/index';

const loginRequest = (payload) => ({
  type: types.auth.LOGIN_REQUEST,
  payload,
});

const logoutRequest = (payload) => ({
  type: types.auth.LOGOUT_REQUEST,
  payload,
});

const getUserRequest = (payload) => ({
  type: types.auth.GET_USER_REQUEST,
  payload
});

const startFetching = () => ({
  type: types.auth.START_FETCHING_LOGIN
});

const stopFetching = () => ({
  type: types.auth.STOP_FETCHING_LOGIN,
});

const setLoginErrors = (payload) => ({
  type: types.auth.SET_ERRORS_LOGIN,
  payload,
});

const setLoginError = (payload) => ({
  type: types.auth.SET_ERROR_LOGIN,
  payload,
});

const getUserStatus = (payload) => ({
  type: types.auth.GET_USER_STATUS,
  payload,
});

const setLoginCrmError = (payload) => ({
  type: types.auth.SET_ERROR_LOGIN_CRM,
  payload,
});

export default {
  loginRequest,
  logoutRequest,
  getUserRequest,
  startFetching,
  stopFetching,
  setLoginErrors,
  setLoginError,
  getUserStatus,
  setLoginCrmError,
};